export class CameraShakeParameters {
    constructor(
        public verticalMagnitudeInDegrees: number,
        public horizontalMagnitudeInDegrees: number,
        public timePerShakeInSeconds: number,
        public count: number
    ) {}
}
